// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.enter-code {
  min-height: calc(100vh - 254px);
}

.disable {
  pointer-events: none;
  opacity: 0.5;
}

.d-btn {
  color: #00823d;
  border: 1px solid #00823d;
  text-transform: uppercase;
  border-radius: 0;
  font-size: 16px;
  padding: 4px 10px;
  background-color: transparent;
}

.input-enter-code {
  background-image: url(https://res.cloudinary.com/lojaali/image/upload/q_auto/v1/SWETROCAMUST22/lock.png);
  background-repeat: no-repeat;
  background-position: right 5px top 6px;
  background-size: 14px;
  padding-right: 26px;
}

.selected-slot {
  display: inline-flex;
  padding: 10px;
  background-color: #007c47;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  margin: 10px 20px;
  width: 80px;
  height: 80px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  color: #fff;
}

@media (max-width: 767px) {
  .calendar {
    width: 70%;
  }
  .enter-code .frame {
    width: 160px;
    height: 160px;
    margin: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/campaign/enter-code/enter-code.component.scss"],"names":[],"mappings":"AAGA;EACI,+BAAA;AAFJ;;AAKA;EACI,oBAAA;EACA,YAAA;AAFJ;;AAKA;EACI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;AAFJ;;AAKA;EACI,wGAAA;EACA,4BAAA;EACA,sCAAA;EACA,qBAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,oBAAA;EACA,aAAA;EACA,yBAAA;EACA,2BAAA;EACA,8BAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AAFJ;;AAKA;EACG;IACC,UAAA;EAFF;EAME;IACI,YAAA;IACA,aAAA;IACA,SAAA;EAJN;AACF","sourcesContent":["@use '../../../../assets/styles/colors' as colors;\n@use '../../../../assets/styles/bootstrap-essentials';\n\n.enter-code {\n    min-height: calc(100vh - 254px);\n}\n\n.disable {\n    pointer-events: none;\n    opacity: 0.5;\n}\n\n.d-btn {\n    color: #00823d;\n    border: 1px solid #00823d;\n    text-transform: uppercase;\n    border-radius: 0;\n    font-size: 16px;\n    padding: 4px 10px;\n    background-color: transparent;\n}\n\n.input-enter-code {\n    background-image: url(https://res.cloudinary.com/lojaali/image/upload/q_auto/v1/SWETROCAMUST22/lock.png);\n    background-repeat: no-repeat;\n    background-position: right 5px top 6px;\n    background-size: 14px;\n    padding-right: 26px;\n}\n\n.selected-slot {\n    display: inline-flex;\n    padding: 10px;\n    background-color: #007c47;\n    border-top-left-radius: 6px;\n    border-bottom-left-radius: 6px;\n    margin: 10px 20px;\n    width: 80px;\n    height: 80px;\n    justify-content: center;\n    align-items: center;\n    flex-wrap: wrap;\n    color: #fff;\n}\n\n@media (max-width: 767px) {\n   .calendar {\n    width: 70%;\n   }   \n   \n   .enter-code {\n    .frame {\n        width: 160px;\n        height: 160px;\n        margin: 0;\n    }\n   }\n}\n\n@include bootstrap-essentials.media-breakpoint-up(lg) {}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
